// Shared constants for the site
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_assist-me-80/artifacts/23vu6qt9_logo.png";

export const COMPANY = {
  name: "Creative Property Development",
  shortName: "Creative Property Dev.",
  tagline: "Building with Vision",
  email: "Hello@creative-property-development.com",
  phone: "732-359-4908",
  phoneMobile: "732-998-0858",
  address: "243 Broadway #9188, Newark, NJ 07104",
  serviceArea: "Serving all of New Jersey · Monmouth County specialist",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Roofing", href: "#roofing" },
  { label: "Work", href: "#work" },
  { label: "Process", href: "#process" },
  { label: "Green", href: "#green" },
  { label: "About", href: "#about" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  {
    n: "01",
    title: "Roof Rejuvenation & Repair",
    desc: "Spray-applied treatment that restores aging asphalt shingles and adds 5–15 years of roof life at a fraction of replacement cost — plus expert repair for leaks, flashing, and storm damage.",
  },
  {
    n: "02",
    title: "General Contracting",
    desc: "Full-scope project management from ground-breaking to final walkthrough — delivered on time, on budget, without surprises.",
  },
  {
    n: "03",
    title: "Custom Home Building",
    desc: "Architect-grade residences built to your brief. A collaborative process that turns blueprints into living, breathing spaces.",
  },
  {
    n: "04",
    title: "Renovations & Remodels",
    desc: "Thoughtful transformations of kitchens, baths, and whole-home rebuilds — preserving what you love, reimagining the rest.",
  },
  {
    n: "05",
    title: "Property Development",
    desc: "End-to-end development: site selection, entitlements, design coordination, and construction — from raw land to ribbon-cutting.",
  },
  {
    n: "06",
    title: "Design-Build",
    desc: "A single accountable team handling both design and construction — fewer handoffs, cleaner budgets, faster completion.",
  },
];

export const PROCESS_STEPS = [
  {
    n: "01",
    label: "Consult",
    desc: "A grounded conversation about site, vision, timeline, and budget. We listen first, recommend second.",
  },
  {
    n: "02",
    label: "Design",
    desc: "Collaborative schematic and design development with architects, engineers, and select specialists.",
  },
  {
    n: "03",
    label: "Build",
    desc: "Transparent scheduling, weekly updates, clean sites. Craftsmanship measured in millimeters.",
  },
  {
    n: "04",
    label: "Deliver",
    desc: "Detailed walkthrough, warranty plan, and an open door for the life of the building.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "They treated the project like their own. The level of care in every detail showed up in the final walkthrough — nothing left to chase.",
    name: "Meredith L.",
    role: "Homeowner · Coastal Build",
  },
  {
    quote:
      "From permitting to punch list, the communication was consistent and the budget held. Rare combination in this industry.",
    name: "David K.",
    role: "Developer · Multi-unit Project",
  },
  {
    quote:
      "Our renovation felt effortless because they did the hard work invisibly. The result is a home that finally feels like ours.",
    name: "Priya S.",
    role: "Homeowner · Full Remodel",
  },
];

export const PROJECT_TYPES = [
  "Roof Rejuvenation",
  "Roof Repair",
  "Custom Home",
  "Renovation",
  "Commercial Build",
  "Property Development",
  "Design-Build",
  "Consultation",
  "Other",
];
